module.exports = __webpack_public_path__ + "media/packs/images/flags/KN-8a751c4f60fd7c7239698401df370936.png";